import { Fragment, useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "../components/common/HeroSection";
import data from "../ourDoctors.json";
import DoctorPhilosophy from "../components/OurDoctors/Doctorphilosophy";
import DoctorsList from "../components/OurDoctors/DoctorsList";
import BookConsultation from "../components/OurDoctors/Book Consultation";
import ImageCardGrid from "../components/common/WhyImageCard";
import DigitalHealthFAB from "../components/Digitalhealth";
import DoctorCardMukta from "../components/OurDoctors/DoctorCardMukta";
import { useClinicSchedule } from "../context/ClinicScheduleContext";

const { doctors } = data;

const OurDoctors = () => {
    const heroSlides = [doctors.hero];
    const location = useLocation();
  const {schedule}=useClinicSchedule();
  console.log(schedule?.schedulingSetup,"mmmmmmmmmmmmmmm");
    useEffect(() => {
    const hash = location.hash?.replace("#", "") || location.state?.scrollTo;
    if (!hash) return;

    // Small timeout ensures the DOM has fully painted before scrolling
    const timer = setTimeout(() => {
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <Fragment>
      <DigitalHealthFAB/>
        <HeroSection slides={heroSlides} />
        <DoctorPhilosophy />

        {/* ↓ id anchor — scrolled to when href="/our-doctors#doctors-list" */}
      <div id="doctors-list">
        {/* <DoctorsList /> */}
        <DoctorCardMukta/>
        </div>

        <ImageCardGrid data={data.whyOurDoctors} />
        <BookConsultation schedule={schedule}/>
        {/* <div className="h-14 md:h-18 lg:h-22 bg-white"></div> */}
    </Fragment>
  );
};

export default OurDoctors;